import $ from 'jquery'
import { createVNode, render as vueRender } from 'vue'
import { SgDropdown, SgDropdownItem } from '@sgui-plus/components/dropdown'
import { SgIcon } from '@sgui-plus/components/icon'
import { MoreVerticalSolid } from '@sgui-plus/icons-vue'
import type { VNode } from 'vue'

let menus: any = []

export function setMenu(data) {
  menus = data
}

export function createMenu(treeId, treeNode) {
  const treeNodeEl = $('#' + treeNode.tId + '_label')
  const treeObj = $.fn.zTree.getZTreeObj(treeId)

  const menuId = `${treeNode.tId}_menu`

  if (treeNode.disableMenu || $(`#${menuId}`).length > 0) return

  const vnode = createVNode(SgDropdown, {
    id: menuId,
    class: 'tree-node-menu',
    trigger: 'hover',
    placement: 'left-start',
    dropClassName: `${treeNode.tId}_popper ${treeId}_popper`,
    onOnClick: (item) => handleClick(item, treeId, treeNode)
  }, {
    default: () => createVNode(SgIcon, { size: 16 }, { default: () => createVNode(MoreVerticalSolid) }),
    menu: () => {
      const childVnodes: VNode[] = []

      menus.forEach(menu => {
        if (menu.vif && !menu.vif.apply(treeObj, [treeNode])) {
          return
        }
        const child = createVNode(SgDropdownItem, { name: menu.value || menu.label }, { default: () => menu.label })
        childVnodes.push(child)
      })

      return childVnodes
    }
  })

  const container = document.createElement('div')

  vueRender(vnode, container)

  treeNodeEl.append(container.firstElementChild)
}

function handleClick(value, treeId, treeNode) {
  const treeObj = $.fn.zTree.getZTreeObj(treeId)

  const item = menus.find(menu => {
    const key = menu.value || menu.label
    return key=== value
  })
  if (item && typeof item.handler === 'function') {
    item.handler.apply(treeObj, [treeNode])
  }
}

export function removeMenu(treeId, treeNode) {
  // $(`#${treeNode.tId}_menu`).remove()
  // $(`.${treeNode.tId}_popper`).remove()
}

export function clearMenu(treeId) {
  $(`.${treeId}_popper`).remove()
}
